import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Axios instance for SUKANACOOP API calls (Feb 2026 — cookie migration).
 *
 * The auth JWT now lives in a `__Host-sukana_session` cookie the browser
 * attaches automatically on same-origin requests when `withCredentials` is on.
 * A companion non-HttpOnly `__Host-sukana_csrf` cookie carries the CSRF token
 * that axios auto-copies into `X-CSRF-Token` on state-changing requests.
 *
 * Legacy `sukana_token` in localStorage is still honoured for a transition
 * window so existing tabs stay logged in until they log out or explicitly
 * clear it.
 */
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  xsrfCookieName: "__Host-sukana_csrf",
  xsrfHeaderName: "X-CSRF-Token",
});

// Axios ≥ 1.6 requires `withXSRFToken: true` for the header to be attached even
// on same-origin requests. It is a no-op on older versions.
api.defaults.withXSRFToken = true;

// Transitional: any legacy caller that still has a token in localStorage keeps
// working until they log back in. Remove after the rollout window (~1 month).
api.interceptors.request.use((config) => {
  const legacy = localStorage.getItem("sukana_token");
  if (legacy && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${legacy}`;
  }
  return config;
});
